import { Injectable } from '@angular/core';
import { Config } from '../models/config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  getConfig() {
    const textContent = document.getElementById('config')?.textContent;

    if (!textContent) {
      throw new Error('unable to get config');
    }

    return JSON.parse(textContent) as Config;
  }
}
